import moment from "moment";
import ApiClient from "../../../libs/apiClient";
import $ from 'jquery';
import { refreshTotal } from "./totals";
import { restartTabs } from "./modal";
import { setDueDateFromPaymentConds } from "../../../libs/utils/GlobalFunc";
import { CURRENCY } from "../../../libs/utils/Const";
import { checkWithHolding } from "./perceptions";
let apiClient = ApiClient.getInstance();
const saveAgentCode = (ctx, partner) => {
    const { newOrderModel } = ctx.props;
    newOrderModel.AgentCode = partner.CardCode;
    newOrderModel.AgentName = partner.CardName;
    refreshTotal(ctx, newOrderModel);
    validateEnter(ctx, 4);
    restartTabs();
    setTimeout(() => {
        ctx.setState({
            partners: [],
            flagAgentCode: false
        });
    }, 100);
}

const validatePartner = (ctx) => {
    const { newOrderModel, view } = ctx.props;

    if ((newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft') && !newOrderModel.CardCode) {
        return false;
    }

    if (view === 'transfers' || view === 'transfersRequest') {
        return true;
    }

    if (newOrderModel.CardCode !== '' && newOrderModel.CardName !== '') {
        return true;
    }
    return false;
};
export const openPartner = async (ctx, index = null, agentCode = false) => {
    const { newOrderModel, view, enableSpinner, showAlert, clearSocio, selectSocio } = ctx.props;

    let CardCode = null;
    if (agentCode) {
        validateEnter(ctx, 3);
        ctx.setState({ flagAgentCode: true });
        CardCode = newOrderModel.AgentCode || CardCode;
    } else {
        validateEnter(ctx, 1);
        CardCode = newOrderModel.CardCode || CardCode;
    }

    let type = 'C';
    if (view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'outgoingPayment' || view === 'landedCosts' || view === 'purchaseDownPayments' || view === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft' || view === 'draft' || newOrderModel.OriginDocumentCreate === "PurchaseOrder") {
        type = 'S';
    } else if (view === 'quotations') {
        type = 'SC';
    }

    if (view === 'PurchaseRequest' && ((newOrderModel?.newView !== 'PurchaseQuotation' && newOrderModel?.newView !== 'PurchaseQuotationDraft' && newOrderModel.OriginDocumentCreate !== "PurchaseOrder") || !newOrderModel?.newView)) {
        newOrderModel.CardCode = newOrderModel.Items[index].LineVendor;
    }

    enableSpinner(true);
    let getPartnerResponse = await apiClient.getPartner(type, CardCode, newOrderModel?.newView || view);
    enableSpinner(false);

    if (getPartnerResponse.status === 0) {
        if (!Array.isArray(getPartnerResponse.data.results)) {
            showAlert({ type: 'info', message: getPartnerResponse.message });
            return;
        }
        if (getPartnerResponse.data.results.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
    }

    if (getPartnerResponse.data.length === 1) {

        if (getPartnerResponse.data[0].validFor === 'N') {
            showAlert({ type: 'error', message: 'El socio de negocio se encuentra inactivo' });
            clearSocio();
            return;
        }

        let Balance = getPartnerResponse.data[0].Balance;
        let credit = getPartnerResponse.data[0].CreditLine;
        let limit = Balance - credit;

        if (view === 'orderSales' || view === "deliveries" || view === 'invoice' || view === 'return' || view === 'creditNote' || view === 'debitNote' || view === "invoiceReserve" || view === "quotations") {
            if (limit > 0) {
                $('#creditLimitModal').modal('show');
                ctx.setState({
                    Codigo: getPartnerResponse.data[0].CardCode,
                    CardName: getPartnerResponse.data[0].CardName,
                    Balance: parseFloat(limit).toFixed(2)
                });
            }
        }

        ctx.setState({
            partners: getPartnerResponse.data,
            partnerType: type
        });


        selectSocio(getPartnerResponse.data[0]);
    } else {
        ctx.setState({
            partners: getPartnerResponse.data.results,
            partnerType: type,
            pageTotal: getPartnerResponse.data.totalPage,
            indexPurchaseRequest: index,
        });
        $('#partnerCreate').modal('show');
    }
};
export const validateEnter = (ctx, option) => {
    const { newOrderModel, refreshModel } = ctx.props;

    switch (option) {
        case 1:
            newOrderModel.partnerSelected = false;
            break;
        case 2:
            newOrderModel.partnerSelected = true;
            break;
        case 3:
            newOrderModel.AgentSelected = false;
            break;
        case 4:
            newOrderModel.AgentSelected = true;
            break;
        default:
            break;
    }
    refreshModel(newOrderModel);
}
export const clearSocio = (ctx, field = '') => {

    let { newOrderModel, view, enableSpinner, showAlert } = ctx.props;
    if (field !== 'AgentCode') {
        let today = moment(new Date()).format('YYYY-MM-DD');
        newOrderModel.CardCode = '';
        newOrderModel.CardName = '';
        //newOrderModel.DocCur =  '';
        newOrderModel.SlpCode = '';
        newOrderModel.SlpName = '';
        newOrderModel.CntctCode = '';
        newOrderModel.CntctName = '';
        newOrderModel.OwnerCode = '';
        newOrderModel.GroupNum = '';
        newOrderModel.GroupName = '';
        newOrderModel.GroupCodeName = '';
        newOrderModel.PymCode = '';
        newOrderModel.PymName = '';
        newOrderModel.ExtraDays = 0;
        newOrderModel.Address = '';
        newOrderModel.deliveriesAddress = [];
        newOrderModel.invoicesAddress = [];
        newOrderModel.ShipToCode = '';
        newOrderModel.Address2 = '';
        newOrderModel.CreditLine = '';
        newOrderModel.PriceListNum = '';
        newOrderModel.LicTradNum = '';
        //impuesto definido desde el usuario
        newOrderModel.TaxeDefaultPartner = '';
        newOrderModel.TaxeRateDefaultPartner = 0;
        newOrderModel.TaxNameDefaultPartner = '';
        newOrderModel.OcrCode2DefaultPartner = '';
        newOrderModel.AcctCodeDefaultPartner = '';
        newOrderModel.CogsAcctDefaultPartner = '';
        newOrderModel.AcctCodeNameDefaultPartner = '';
        newOrderModel.CogsAcctNameDefaultPartner = '';
        //PAGOS RECIBIDOS Y PAGOS EFECTUADOS
        //newOrderModel.ItemsPayments
        newOrderModel.TrsfrAcctFormatCode = '';
        newOrderModel.TrsfrRef = '';
        newOrderModel.TrsfrSum = '';
        newOrderModel.CheckAcctFormatCode = '';
        newOrderModel.CashAcctFormatCode = '';
        newOrderModel.CashSum = 0;
        newOrderModel.CounterRef = '';
        newOrderModel.Comments = '';
        newOrderModel.JrnlMemo = '';
        newOrderModel.ItemsPayments = [];
        newOrderModel.DocDueDate = today;
        newOrderModel.U_FMB_END_DATE = today;
        validateEnter(ctx, 1);
    } else {
        newOrderModel.AgentCode = '';
        newOrderModel.AgentName = '';
        validateEnter(ctx, 3);
    }

    refreshTotal(ctx, newOrderModel);
    restartTabs();
    setTimeout(() => {
        ctx.setState({
            partners: [],
            partnerType: null,
            pageTotal: 0,
            indexPurchaseRequest: null,
        });
    }, 100);
};
export const changeCardCode = async (ctx, event) => {
    const { newOrderModel } = ctx.props;
    clearSocio(ctx, event.nativeEvent.target.name);
    if (event.nativeEvent.data !== '') {
        if (event.nativeEvent.target.name !== 'AgentCode') {
            newOrderModel.CardCode = event.nativeEvent.target.value;
        } else {
            newOrderModel.AgentCode = event.nativeEvent.target.value;
        }
    }
    // this.refreshModel(newOrderModel);
};
export const refreshPartner = async (ctx, partner, totalPage) => {
    ctx.setState({
        partners: partner,
        pageTotal: totalPage
    });
}
export const selectPartner = async (ctx, action, newIndex = null) => {
    const { partners, U_FMB_DEF_PLReqStockTransfer, U_FMB_DEF_PLStockTransfer, flagAgentCode } = ctx.state;
    let { newOrderModel, view, enableSpinner, showAlert, getDimension1 } = ctx.props;
    let partner = partners[action.index];
    let Balance = partner.Balance;
    let credit = partner.CreditLine;
    let limit = Balance - credit;
    let newView = newOrderModel.newView || view;

    if (partner.validFor === 'N') {
        showAlert({ type: 'error', message: 'El socio de negocio se encuentra inactivo' });
        let field = flagAgentCode ? 'AgetCode' : '';
        clearSocio(ctx, field);
        return;
    }

    if (view === 'landedCosts' && flagAgentCode) {
        saveAgentCode(ctx, partner);
        $('#partnerCreate').modal('hide');
        return;
    }

    if (view === 'quotations' || view === 'orderSales' || view === "deliveries" || view === 'invoice' || view === 'return' || view === 'creditNote' || view === 'debitNote' || view === "invoiceReserve") {
        if (limit > 0) {

            $('#creditLimitModal').modal('show');
            ctx.setState({
                Codigo: partner.CardCode,
                CardName: partner.CardName,
                Balance: parseFloat(limit).toFixed(2)
            });
        }
    }
    try {
        enableSpinner(true)
        let getCurrencies = await apiClient.getCurrencies();
        enableSpinner(false)
        partner.Currency = partner.Currency === '##' ? CURRENCY : partner.Currency;
        let selectDocCur = getCurrencies.data.filter((currency) => currency.CurrCode === partner.Currency) || 1;
        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.CardName = partner.CardName;
        newOrderModel.Email = partner.E_mail || '';
        newOrderModel.DocCur = partner.Currency || '';
        newOrderModel.ChangeRate = selectDocCur[0].Rate || 1;
        newOrderModel.SlpCode = partner.SlpCode || '';
        newOrderModel.SlpName = partner.SlpName || '';
        newOrderModel.CntctCode = partner.CodigoContacto || '';
        newOrderModel.CntctName = partner.Contacto || '';
        newOrderModel.OwnerCode = partner.OwnerCode || '';
        newOrderModel.GroupNum = partner.GroupNum || ''; // first Branch office Price List 
        newOrderModel.GroupName = partner.PymntGroup || '';
        newOrderModel.GroupCode = partner.GroupCode || '';
        newOrderModel.GroupCodeName = partner.GroupCodeName || '';
        newOrderModel.PymCode = partner.PymCode || '';
        newOrderModel.ExtraDays = partner.ExtraDays || 0;
        newOrderModel.PymName = partner.Descript || '';
        newOrderModel.Address = partner.Address || '';
        newOrderModel.deliveriesAddress = [];
        newOrderModel.invoicesAddress = [];
        newOrderModel.ShipToCode = '';
        newOrderModel.Address2 = '';
        newOrderModel.PriceListNum = partner.ListNum || '';
        newOrderModel.Balance = partner.Balance || '';
        newOrderModel.CreditLine = partner.CreditLine || 0;
        newOrderModel.E_Mail = partner.E_Mail;
        newOrderModel.ItemsPayments = [];
        newOrderModel.OcrCode2 = partner.OcrCode2;
        newOrderModel.LicTradNum = partner.LicTradNum || '';
        //BRANCH OFFICE CONFIG PRICE LIST
        if (view === 'transfersRequest') {
            newOrderModel.GroupNum = U_FMB_DEF_PLReqStockTransfer !== null ? Number(U_FMB_DEF_PLReqStockTransfer) : partner.GroupNum || ''; // first Branch office Price List (REQUEST TRANSFER)
        }
        if (view === 'transfers') {
            newOrderModel.GroupNum = U_FMB_DEF_PLStockTransfer !== null ? Number(U_FMB_DEF_PLStockTransfer) : partner.GroupNum || ''; // first Branch office Price List (stockTransfer)
        }

        //impuesto definido desde el usuario

        if (partner.CardType === 'C') {
            newOrderModel.TaxeDefaultPartner = partner.TaxCode || '';
            newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 16;
            newOrderModel.TaxNameDefaultPartner = partner.TaxCodeName || '';
        } else {
            newOrderModel.TaxeDefaultPartner = partner.VatGroup || '';
            newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 16;
            newOrderModel.TaxNameDefaultPartner = partner.TaxCodeName || '';
        }
        //newOrderModel.TaxeRateDefaultPartner = partner.TaxCodeRate || 0;
        newOrderModel.OcrCode2DefaultPartner = partner.OcrCode2 || '';
        newOrderModel.AcctCodeDefaultPartner = partner.AcctCodeItem || '';
        newOrderModel.CogsAcctDefaultPartner = partner.CogsAcctItem || '';
        newOrderModel.AcctCodeNameDefaultPartner = partner.AcctCodeItemName || '';
        newOrderModel.CogsAcctNameDefaultPartner = partner.CogsAcctItemName || '';

        //pagos
        newOrderModel.BpAct = partner.AcctCode || '';
        newOrderModel.BpActName = partner.AcctName || '';
        newOrderModel.BpActFormatCode = partner.FormatCode || partner.BpActFormatCode;
        newOrderModel.BpActCopy = partner.AcctCode || '';
        newOrderModel.BpActNameCopy = partner.AcctName || '';
        newOrderModel.BpActFormatCodeCopy = partner.FormatCode || '';

        newOrderModel.U_FMB_DescPP = Number(partner.U_FMB_DescPP || 0);

        // newOrderModel = await this.updateItemsWhenPartnerChange(newOrderModel);
        enableSpinner(true)
        let getAddressResponse = await apiClient.getAddressParter(newOrderModel.CardCode);
        enableSpinner(false)

        let address = [];
        if (view !== 'PurchaseRequest') {
            if (partner.CardType === 'C') {
                let searchDefault = getAddressResponse.data.deliveriesAddress.find(address => address.Address === partner.ShipToDef);
                address = searchDefault ? searchDefault : getAddressResponse.data.deliveriesAddress[0] || [];
            } else {
                address = getAddressResponse.data.invoicesAddress[0] || [];
            }

            newOrderModel.ShipToCode = address ? address.Address : '';
            newOrderModel.Address2 = (address.Street ? address.Street : '') + ' ' + (address.Block ? address.Block : '') + '  ' + (address.City ? address.City : '') + ' ' + (address.ZipCode ? address.ZipCode : '') + ' ' + (address.State ? address.State : '') + ' ' + (address.Country ? address.Country : '') || "";
            if (newOrderModel?.isSalesDocument && newOrderModel?.ShipToCode && address?.AdresType === 'S') { // NEW PROJECT LOGIC
                newOrderModel.Project = address?.U_FMB_Project || '';
            }
        }
        // SCOP validation 
        newOrderModel.NeedScopCode = address?.U_FMB_FICHA_OSIN ? true : false;
        //#region ################## PERCEPCION ################ ✔
        newOrderModel.U_BPP_BPTD = partner.U_BPP_BPTD;
        newOrderModel.U_STR_AR = partner.U_STR_AR;
        newOrderModel.U_STR_AP = partner.U_STR_AP;
        newOrderModel.U_LLG_EXCEPTUADO_PERCEPCION = partner.U_LLG_EXCEPTUADO_PERCEPCION;
        //#endregion ################## PERCEPCION ################ ✔

        //#region CENTROS DE COSTOS
        // for (let index = 0; index < newOrderModel.Items.length; index++) {
        // const item = newOrderModel.Items[index];
        //CENTROS DE COSTOS 
        //CENTRO DE COSTO 1
        //item.OcrCode = '';
        //CENTRO DE COSTO 2
        // item.OcrCode2 = partner.OcrCode2;
        //CENTRO DE COSTO 3
        //item.OcrCode3 = '';
        //CENTRO DE COSTO 4
        // item.OcrCode4 = '';
        //CENTROS DE COSTOS 

        // }
        //#endregion

        //#region DIMENSIONS
        if (newOrderModel.isSalesDocument && newOrderModel.DocType === 'I') {
            enableSpinner(true)
            newOrderModel.Dimension1 = await getDimension1(newOrderModel);
            enableSpinner(false)
            if (newOrderModel.Dimension1) {
                for (const item of newOrderModel?.Items) {
                    item.OcrCode = newOrderModel.Dimension1;
                }
                if (newOrderModel?.Items?.length) {
                    showAlert({ type: 'info', message: `La dimensión 1 llamada "CANAL" de los artículos ha cambiado conforme al socio`, timeOut: 8000 });
                }
            }
        }
        //#endregion DIMENSIONS

        if (newOrderModel.isPurchaseDocument) {
            newOrderModel.WTCodes = partner.WTCodes || [];
            //#region DETRACCIONES
            if (newOrderModel.DetraccionVista || newView === 'PurchaseOrder') {
                newOrderModel.WTCodesD = partner.WTCodesD || [];
                newOrderModel.U_FMB_BP_Detra = newOrderModel?.WTCodesD?.length ? 'Y' : 'N';
            }
            //#endregion DETRACCIONES
        }

        //#region RETENCIONES
        if (newOrderModel.RetencionVista || newView === 'PurchaseOrder') {
            newOrderModel.WTCodesR = partner?.WTCodesR || [];
            newOrderModel.WTCodesR = newOrderModel.WTCodesR?.filter(wtcode => (wtcode.WTCode || wtcode.WTName || '')?.includes('3%')) ?? [];
            newOrderModel.U_FMB_BP_Reten = newOrderModel?.WTCodesR?.length ? 'Y' : 'N';
            newOrderModel.U_STR_BC = partner.U_STR_BC || 'N';
            enableSpinner(true)
            newOrderModel = await checkWithHolding(newOrderModel);
            enableSpinner(false)
        }
        //#endregion RETENCIONES

        //#region PRECIOS ESPECIALES
        if (newOrderModel.Items.length > 0 && (view === 'orderSales')) {
            let CardCode = newOrderModel.CardCode;
            let DocDate = newOrderModel.DocDate;
            enableSpinner(true);
            let getItemResponse = await apiClient.getItemsPrice(CardCode, newOrderModel.Items, DocDate);
            enableSpinner(false);
            if (getItemResponse.status === 1) {
                newOrderModel.Items = getItemResponse.data;
            }
        }
        //#endregion


        //Calculo fecha de entrega 
        let today = moment(new Date()).format('YYYY-MM-DD');
        if (view === 'invoice' || view === 'orderSales' || view === 'debitNote' || view === 'invoiceReserve') {


            let grouNum = newOrderModel.GroupNum;
            let groupName = newOrderModel.GroupName;
            let extraDays = newOrderModel.ExtraDays;
            let typeInvoice = 0;
            // let userFieldTypeInvoice = newOrderModel.userFields.userFields3;
            // if(userFieldTypeInvoice === 'Contado' || (groupName === 'Pago Inmediato' && grouNum === 9)){
            //     typeInvoice = 3;
            // }else if(userFieldTypeInvoice === 'Credito'){
            //     typeInvoice = 14
            // }else if(userFieldTypeInvoice === 'Credito2'){
            //     if(extraDays > 28){
            //         typeInvoice = extraDays;
            //     }else{
            //         typeInvoice = 28;
            //     }
            // }else if (groupName != '' && extraDays != 0){
            //     typeInvoice = extraDays;
            // }
            if (typeInvoice == 0) {
                typeInvoice = extraDays ? extraDays : Number(newOrderModel?.GroupNum) === -1 ? 0 : 3;
            }
            let docDueDate = new Date(today);
            docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
            let weekDays = 0;
            while (weekDays < typeInvoice) {
                docDueDate.setDate(docDueDate.getDate() + 1);
                // if(docDueDate.getDay() != 0){
                weekDays++;
                // }
            }
            newOrderModel.DocDueDate = moment(docDueDate).format('YYYY-MM-DD');
        }
        newOrderModel.U_FMB_END_DATE = newOrderModel.DocDueDate;

        const data = {
            GroupNum: newOrderModel.GroupNum,
            view,
            showAlert,
            model: newOrderModel,
            enableSpinner
        }
        await setDueDateFromPaymentConds(data)

        refreshTotal(ctx, newOrderModel);
        validateEnter(ctx, 2);
        //#region SOLICITUD DE COMPRA
        if (view === 'PurchaseRequest') {
            newOrderModel.Items[newIndex.indexPurchaseRequest].LineVendor = partner.CardCode;
            newOrderModel.CardCode = '';
            await validateEnter(ctx, 1);
            refreshTotal(ctx, newOrderModel);
        }
        //#endregion
        $('#partnerCreate').modal('hide');
        restartTabs();
        setTimeout(() => {
            ctx.setState({
                partners: [],
            });
        }, 100);
    } catch {
        showAlert({ type: 'warning', message: 'Información de socio incompleta, no tiene direcciónes' });

        $('#partnerCreate').modal('hide');
        restartTabs();
        setTimeout(() => {
            ctx.setState({
                partners: [],
            });
        }, 100);
    }
};
export const openPersonContact = async (ctx) => {
    const { showAlert, newOrderModel, enableSpinner } = ctx.props;
    if (!validatePartner(ctx)) {
        showAlert({ type: 'info', message: 'Selecciona un socio de negocios' });
        return;
    }
    enableSpinner(true);
    let getContactsResponse = await apiClient.getContactsList(newOrderModel.CardCode);
    enableSpinner(false);

    if (!Array.isArray(getContactsResponse.data)) {
        showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
        return;
    }

    if (getContactsResponse.data.length === 0) {
        showAlert({ type: 'info', message: 'No hay Información por mostrar' });
        return;
    }

    ctx.setState({
        contacts: getContactsResponse.data,
    });
    $('#personContactModal').modal('show');
};
export const selectContact = (ctx, action) => {
    const { contacts } = ctx.state;
    const { newOrderModel, refreshModel } = ctx.props;
    let contact = contacts[action.index];

    newOrderModel.CntctCode = contact.CntctCode || '';
    newOrderModel.CntctName = contact.CntctName || '';

    refreshModel(newOrderModel);
    $('#personContactModal').modal('hide');
    setTimeout(() => {
        ctx.setState({
            contacts: [],
        });
    }, 100);
};

